import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getProjectViewResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
import { RedirectToLastVisitedProjectPage } from '@jira/router-routes__common/src/ui/last-visited-project-page/index.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { businessProjectLayout } from '@jira/platform__layouts-business-project-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jiraBusinessProjectRedirectRoute } from '@jira/router-routes__business-redirect-routes/src/jiraBusinessProjectRedirectRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const jiraBusinessProjectRedirectRouteEntry: Route = createEntry(
	jiraBusinessProjectRedirectRoute,

	() => ({
		group: 'classic-business',
		isRedirect: true,
		// eslint-disable-next-line no-restricted-syntax
		component: RedirectToLastVisitedProjectPage,
		layout: businessProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncHorizontalNavJira,
		},

		resources: getProjectViewResources(),
		forPaint: [LazyAtlassianNavigation],

		supportsProjectTheme: 'full',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
